import { XmlType } from './xml-type';

export interface XmlMapping {
  field: string;
  xml: string;
  type: XmlType;
  mappings?: XmlMapping[];
}
